import { useQuery } from '@tanstack/react-query';
import { debounce } from 'lodash';
import { fetcher } from '../libs';

type License = {
  issuer: string;
  name: string;
  licenseIssuerId: string;
};

const fetchLicenses = debounce(async (searchName?: string) => {
  return fetcher<License[]>(`/license-issuers/search?name=${searchName}`);
}, 300);

export default function useSearchLicenseQuery(searchName?: string) {
  return useQuery(
    ['license', 'search', searchName],
    async () => {
      return fetchLicenses(searchName);
    },
    {
      enabled: Boolean(searchName)
    }
  );
}
